import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";
import { resetAuth } from "../components/Auth/AuthProvider";
import { navigateTo } from "./navigationService";

class ApiService {
  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
    });

    /* ⭐ AUTO ATTACH CSRF TOKEN FOR EVERY REQUEST */
    this.api.interceptors.request.use(
      (config) => {
        const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);

        if (match) {
          config.headers["X-XSRF-TOKEN"] = decodeURIComponent(match[1]);
        }

        return config;
      },
      (error) => Promise.reject(error)
    );

    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401 && error?.config?.url !== "/auth/check" && error?.config?.url !== "/tourism-details") {
          resetAuth();
          navigateTo("/", { replace: true });
        }
        return Promise.reject(error);
      }
    );
  }

  async initCsrf() {
    await this.api.get("/sanctum/csrf-cookie");
  }

  async get(endpoint, config = {}) {
    return this.api.get(endpoint, config).then((res) => res.data);
  }

  async post(endpoint, data, config = {}) {
    return this.api.post(endpoint, data, config).then((res) => res.data);
  }

  async put(endpoint, data, config = {}) {
    return this.api.put(endpoint, data, config).then((res) => res.data);
  }

  async delete(endpoint, config = {}) {
    return this.api.delete(endpoint, config).then((res) => res.data);
  }
}

export default new ApiService();